module.exports = __webpack_public_path__ + "img/logout.3b57ea4a.svg";